import { useIntlAccaRolls } from "../../intl-acca/useIntlAccaRolls.ts";
import { RollsIntlPage } from "./RollsIntlPage.tsx";

export function IntlAccaRollsRoute(): JSX.Element {
  const vm = useIntlAccaRolls();

  return (
    <RollsIntlPage
      loading={vm.loading}
      error={vm.error}
      tournament={vm.tournament}
      rolls={vm.rolls}
      matchLabels={vm.matchLabels}
      matchCodes={vm.matchCodes}
    />
  );
}
